<template>
  <span class="list-beers">
    <div class="tabs is-centered sticky">
      <ul>
        <li class="is-hidden-mobile"><strong>Sortera:</strong></li>
        <li @click="setSorting('average')" v-bind:class="{'is-active': sortBy === 'average'}">
          <a>
            Betyg
            <i v-bind:class="['fa', sortValue ? 'fa-sort-asc' : 'fa-sort-desc']"></i>
          </a>
        </li>
        <li @click="setSorting('name')" v-bind:class="{'is-active': sortBy === 'name'}">
          <a>
            Öl
            <i v-bind:class="['fa', sortValue ? 'fa-sort-asc' : 'fa-sort-desc']"></i>
          </a>
        </li>
        <li @click="setSorting('brewery')" v-bind:class="{'is-active': sortBy === 'brewery'}">
          <a>
            Bryggeri
            <i v-bind:class="['fa', sortValue ? 'fa-sort-asc' : 'fa-sort-desc']"></i>
          </a>
        </li>
        <li @click="setSorting('date')" v-bind:class="{'is-active': sortBy === 'date'}">
          <a>
            Datum
            <i v-bind:class="['fa', sortValue ? 'fa-sort-asc' : 'fa-sort-desc']"></i>
          </a>
        </li>
        <li @click="toggleSearch()">
          <i class="fa fa-search"></i>
        </li>
      </ul>
    </div>

    <div class="section" v-if="showSearch">
      <form class="form-group">
        <input class="input is-medium" type="text" placeholder="Har vi haft den förut? (dvs ölen)" v-model="query" />
      </form>
    </div>

    <div class="section columns is-multiline">
      <div class="column is-one-third-tablet" v-for="beer in orderBy(beerData)">
        <article class="media">
          <figure class="media-left">
            <p class="image">
              <div class="average-score">{{ beer.average }}</div>
              <img v-if="beer.img" :src="beer.img" class="page-header__image">
              <img v-else src="static/default-beer.jpg" class="page-header__image">
            </p>
          </figure>
          <div class="media-content">
            <div class="content">
              <p>
                <h2 class="title">{{ beer.name }}</h2>
                <h4 class="subtitle">{{beer.brewery}}</h4>
                <small>
                  <table class="table is-narrow is-striped is-fullwidth">
                    <tr v-for="user in sortedRatings(beer.ratings)">
                      <td>{{user.name}}</td>
                      <td class="rating-info">
                        <span class="rating-info__bar" v-bind:style="{width: user.rating * 20 + 'px'}"></span>
                        <span class="rating-info__score">{{ user.rating }}</span>
                      </td>
                    </tr>
                  </table>
                  <p>Provtillfälle: {{beer.date}}<br />
                  Ölmästare: {{beer.boughtBy}}</p>
                </small>
              </p>
            </div>
          </div>
        </article>
      </div>
    </div>
  </span>
</template>

<script>
import _ from 'lodash'

export default {
  data () {
    return {
      sortBy: 'date',
      sortOrder: ['desc', 'asc'],
      sortValue: 0,
      query: '',
      showSearch: false
    }
  },
  computed: {
    beerData: function () {
      let result = this.$store.getters.data

      if (this.query) {
        let query = this.query.toLowerCase()
        result = result.filter(item => item.name.toLowerCase().includes(query))
      }
      return result
    }
  },
  methods: {
    sortedRatings: function (ratings) {
      return _.orderBy(ratings, 'rating', 'desc')
    },
    orderBy: function (beers) {
      return _.orderBy(beers, this.sortBy, this.sortOrder[this.sortValue])
    },
    setSorting: function (key) {
      this.sortBy = key
      this.invertSort()
    },
    invertSort: function () {
      this.sortValue = 1 - this.sortValue
    },
    toggleSearch: function () {
      this.showSearch = !this.showSearch
    }
  }
}
</script>

<style lang="scss">
@import '../assets/styles/config.scss';

.list-beers {
  .section {
    padding: 3.5rem 1rem 0;
  }

  .fa-sort-asc,
  .fa-sort-desc {
    display: none;
  }

  .is-active {
    .fa-sort-asc,
    .fa-sort-desc {
      display: block;
      padding-left: 4px;
    }
  }
  .fa-search {
    color: $color_dark;
    cursor: pointer;
    font-size: 16px;
    margin-left: 6px;
    padding-top: 6px;
  }
}
.sticky {
  background-color: #fff;
  left: 0;
  margin-bottom: 10px;
  padding-top: 48px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 5;
}

.page-header__image {
  max-height: 180px;
}
.rating {
  margin-bottom: 20px;
}

.media {
  background-color: #fff;
  padding: 20px 0;
}
@media (min-width: 768px) {
  .columns {
    background-color: #fff;
  }
  .columns:last-child {
    margin-bottom: 0;
  }
}

@media (max-width: 768px) {
  .columns.is-multiline {
    margin-right: 0;
  }
  .column.is-one-third-tablet {
    padding: 10px 0 10px 10px;
  }
}

.average-score {
  align-items: center;
  background-color: $color_accent;
  border-radius: 50%;
  color: #fff;
  display: flex;
  font-size: 20px;
  font-weight: bold;
  height: 60px;
  justify-content: center;
  margin: auto;
  margin-bottom: 20px;
  padding: 10px;
  width: 60px;
}
.table {
  &.is-narrow {
    td {
      padding: 0.5em 0.5em 0;
    }

    td + td {
      padding: 5px 2px;
    }
  }
}

.rating-info {
  position: relative;
  width: 100px;
  font-weight: 700;

  &__bar {
    position: absolute;
    background-color: lighten($color_dark, 20%);
    left: 0;
    height: 4px;
    top: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// ListBeers.vue?176d4ac0